import {faHeadset} from '@fortawesome/free-solid-svg-icons';

export default [
    {
        to: "/admin/networking/support-tickets",
        icon: faHeadset,
        title: "Support Tickets",
        feature: 'support_tickets'
    },
];